import { MutationTree } from 'vuex';
import { AttachmentState } from './types';

export const mutations: MutationTree<AttachmentState> = {
  STORE(state, data: AttachmentState) {
    state.attachDocuments = data.attachDocuments
    state.locationFilesInfo = data.locationFilesInfo
  },
  CLEAR(state) {
    state.attachDocuments = false
    state.locationFilesInfo = []
  }
}
